import urql from '@urql/vue'
import { createClient, cacheExchange, fetchExchange } from '@urql/core'

const API_DOMAIN = window.location.origin // proxied by CloudFront or vite in local dev

// Inject headers per request; keep fetchOptions synchronous to satisfy types
const customFetch: typeof fetch = async (input, init) => {
  const headers = new Headers(init?.headers || {})
  // Respect per-request override if provided; otherwise default to Bostello
  if (!headers.has('broker-id')) {
    headers.set('broker-id', 'bostello')
  }
  headers.set('Content-Type', 'application/json')
  // Match actual dev origin so CORS + session cookies align with localhost vite proxy
  const adminOrigin =
    import.meta.env.DEV
      ? window.location.origin
      : 'https://admin.platform.bostello.com'
  headers.set('Origin', adminOrigin)
  // For all GraphQL requests, bypass HTTP caches to ensure fresh data
  if (!headers.has('Cache-Control')) headers.set('Cache-Control', 'no-cache')

  return fetch(input as RequestInfo, {
    ...(init || {}),
    headers,
    cache: 'no-store' as RequestCache,
  })
}

const client = createClient({
  url: `${API_DOMAIN}/graphql`,
  exchanges: [cacheExchange, fetchExchange],
  fetch: customFetch as typeof fetch,
  fetchOptions: () => ({
    // Still allow cookies if present; primary auth via Authorization header
    credentials: 'include' as RequestCredentials,
  }),
})

export default urql
export { client }
